import React from 'react';
import { GLOBAL_PAGE_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import { ForgeAnalyticsWrapper } from '../../common/ui/index.tsx';
import type {
	AnalyticsWrapperPropsView,
	AnalyticsWrapperPropsTrigger,
} from '../../common/ui/types.tsx';
import { MODULE_TYPE_TRIGGER } from '../../constants.tsx';

export const ViewAnalyticsWrapper = (props: AnalyticsWrapperPropsView): React.JSX.Element => (
	<ForgeAnalyticsWrapper module={GLOBAL_PAGE_MODULE} shouldFireInitializedEvent {...props} />
);

export const TriggerAnalyticsWrapper = (props: AnalyticsWrapperPropsTrigger): React.JSX.Element => (
	<ForgeAnalyticsWrapper module={GLOBAL_PAGE_MODULE} moduleType={MODULE_TYPE_TRIGGER} {...props} />
);
